// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".map-component-container{width:100%;height:100%;padding:10px}.map-component-container.is-being-marked .leaflet-container{cursor:crosshair}.ui-field-map-ui-footer{margin-top:20px;display:flex;align-items:center;justify-content:flex-start}.ui-field-map-ui-footer .footer-icon{flex-grow:0;margin-right:15px}.ui-field-map-ui-footer .footer-label{flex-grow:1;font-weight:bold}", ""]);
// Exports
module.exports = exports;
